var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { searchMedicationLists } from '../Async/MedicationListsAsync';
import { MedicationListsDataTable } from '../Components/DataTable/MedicationListsDataTable';
import { TwoPanelLayout } from '../Components/TwoPanelLayout';
import { useAsync } from '../Hooks/useAsync';
import { useDebounce } from '../Hooks/useDebounce';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { isMedListFiltered, MedicationListFilter, useMedicationListFilter } from './MedicationListFilter';
import styles from './MedicationLists.module.css';
export var MedicationLists = function (props) {
    var _a;
    var httpConfig = useHttpConfig();
    var debounceQuery = useDebounce(props.query);
    var medicationListsAsync = useAsync({
        defaultValue: null,
        httpConfig: httpConfig,
        getApi: searchMedicationLists
    });
    var doMedListRequest = function (filter) { return __awaiter(void 0, void 0, void 0, function () {
        var apiFilter;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    apiFilter = {
                        status: ((_a = filter.status) === null || _a === void 0 ? void 0 : _a.value) === 'All' ? null : (_c = (_b = filter.status) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : null,
                        types: filter.types.map(function (it) { return it.value; })
                    };
                    return [4 /*yield*/, medicationListsAsync.getApi(filter.limit === 0 ? 0 : filter.limit + 1, debounceQuery, apiFilter)];
                case 1:
                    _d.sent();
                    setFiltered(debounceQuery !== '' || isMedListFiltered(filter));
                    return [2 /*return*/];
            }
        });
    }); };
    var filterState = useMedicationListFilter(doMedListRequest);
    var _b = __read(useState(props.query !== '' || isMedListFiltered(filterState.state)), 2), filtered = _b[0], setFiltered = _b[1];
    var getMedicationLists = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            doMedListRequest(filterState.state);
            return [2 /*return*/];
        });
    }); };
    var medicationLists = (_a = medicationListsAsync.data) !== null && _a !== void 0 ? _a : [];
    useEffect(function () {
        getMedicationLists();
    }, [debounceQuery]);
    return (React.createElement("div", { className: styles.dashboard },
        React.createElement(TwoPanelLayout, { leftPanelOpen: props.filtersActive, noPadding: true, leftPanel: React.createElement(MedicationListFilter, __assign({}, filterState)), contents: React.createElement(React.Fragment, null,
                React.createElement(MedicationListsDataTable, { filtered: filtered, medicationLists: medicationLists, loadCount: medicationListsAsync.loadCount, limit: filterState.state.limit, hasSearchString: false, loadStatus: medicationListsAsync.status, onAddMedicationList: props.onAddMedicationList, onDelete: function () {
                        getMedicationLists();
                    }, onEditClick: props.onEditClick }),
                !!props.children &&
                    props.children({
                        refresh: getMedicationLists
                    })) })));
};
